(function () {
  var EXPERIMENT_ID = 'b7cb019a-7c4d-4ae9-b399-942a260420fa';
  var BANNER_ATTRIBUTE_KEY = 'banner_variant';
  var BANNER_ATTRIBUTE_VALUE = 'show';

  function isVariantB() {
    try {
      var group = window.igData && window.igData.user && window.igData.user.getTestGroup(EXPERIMENT_ID);
      return group && group.name === 'Variant B';
    } catch (e) {
      return false;
    }
  }

  function syncCartAttribute(value) {
    var body = { attributes: {} };
    body.attributes[BANNER_ATTRIBUTE_KEY] = value;
    window.__igOriginalFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).catch(function () {});
  }

  function injectAttributeIntoBody(init, value) {
    if (!init || !init.body) return init;

    var contentType = '';
    if (init.headers) {
      if (typeof init.headers.get === 'function') {
        contentType = init.headers.get('Content-Type') || '';
      } else {
        contentType = init.headers['Content-Type'] || '';
      }
    }

    if (contentType.indexOf('application/json') !== -1) {
      try {
        var body = JSON.parse(init.body);
        body.attributes = body.attributes || {};
        body.attributes[BANNER_ATTRIBUTE_KEY] = value;
        return Object.assign({}, init, { body: JSON.stringify(body) });
      } catch (e) {
        return init;
      }
    }

    if (init.body instanceof FormData) {
      init.body.append('attributes[' + BANNER_ATTRIBUTE_KEY + ']', value);
      return init;
    }

    return init;
  }

  window.__igOriginalFetch = window.fetch;

  window.fetch = async function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';

    var isCartAdd = url.indexOf('cart/add') !== -1;
    var isCartChange = url.indexOf('cart/change') !== -1;
    var isCartUpdate = url.indexOf('cart/update') !== -1;
    var isCartGet = url.indexOf('cart.js') !== -1 || url.indexOf('cart/get') !== -1;

    var isTracked = isCartAdd || isCartChange || isCartUpdate || isCartGet;

    if (!isTracked) {
      return window.__igOriginalFetch.call(this, input, init);
    }

    var variantB = isVariantB();

    // Inject attribute directly into body for add/update
    if (isCartAdd || isCartUpdate) {
      init = injectAttributeIntoBody(init, variantB ? BANNER_ATTRIBUTE_VALUE : '');
    }

    var response = await window.__igOriginalFetch.call(this, input, init);

    // For change/get: check full cart response and sync attribute only if needed
    if ((isCartChange || isCartGet) && response.ok) {
      try {
        var cartData = await response.clone().json();
        var currentValue = cartData.attributes && cartData.attributes[BANNER_ATTRIBUTE_KEY];
        if (variantB && currentValue !== BANNER_ATTRIBUTE_VALUE) {
          syncCartAttribute(BANNER_ATTRIBUTE_VALUE);
        } else if (!variantB && currentValue) {
          syncCartAttribute('');
        }
      } catch (e) {}
    }

    return response;
  };
})();
